import { gql } from "@apollo/client";
import { APPLICANT_ACTIVITY_FIELDS } from "graphql/fragments";

const SHORTLIST_APPLICANT = gql`
  mutation shortlistMissionRoleApplicants($input: ShortlistMissionRoleApplicantsInput!) {
    shortlistMissionRoleApplicants(input: $input) {
      shortlisted {
        id
        message
        notification {
          required
          sent
        }
        profile {
          name
        }
      }
      failedToShortlist {
        id
        message
        profile {
          name
        }
      }
    }
  }
`;

const UNSELECT_APPLICANT = gql`
  mutation unselectMissionRoleApplicants($input: UnselectMissionRoleApplicantsInput!) {
    unselectMissionRoleApplicants(input: $input) {
      unselected {
        id
        message
        notification {
          required
          sent
        }
      }
      failedToUnselect {
        id
        message
      }
    }
  }
`;

const SUBMIT_APPLICATION = gql`
  mutation submitMissionRoleApplication($input: SubmitMissionRoleApplicationInput!) {
    submitMissionRoleApplication(input: $input) {
      missionRoleApplicant {
        id
        state
        appliedAt
        profile {
          id
          status
          submittedAt
        }
      }
    }
  }
`;

const UPDATE_APPLICANT = gql`
  mutation updateMissionRoleApplicant($input: UpdateMissionRoleApplicantInput!) {
    updateMissionRoleApplicant(input: $input) {
      missionRoleApplicant {
        id
        rate {
          amount
          currency
          frequency
        }
        notSelectedReasons {
          id
          name
        }
        negotiatedRate {
          amount
          currency
          frequency
        }
        negotiatedSellingRate {
          amount
          currency
          frequency
        }
        acceptedRequirements {
          id
          description
        }
        applicationChecklist
        noticePeriod
        availablePartTimeDuringNotice
        clientNotes
        clientNotesJson
        privateNotes
        privateNotesJson
      }
    }
  }
`;

const SELECT_APPLICANT = gql`
  mutation selectMissionRoleApplicants($input: SelectMissionRoleApplicantsInput!) {
    selectMissionRoleApplicants(input: $input) {
      selected {
        id
        state
      }
      failedToSelect {
        id
        state
      }
    }
  }
`;

const WITHDRAW_APPLICATION = gql`
  mutation withdrawMissionRoleApplication($input: WithdrawMissionRoleApplicationInput!) {
    withdrawMissionRoleApplication(input: $input) {
      missionRoleApplicant {
        id
        state
      }
    }
  }
`;

const INTERVIEW_APPLICANT = gql`
  mutation interviewedMissionRoleApplicants($input: InterviewedMissionRoleApplicantsInput!) {
    interviewedMissionRoleApplicants(input: $input) {
      interviewed {
        id
        state
      }
      failedToInterviewed {
        id
        state
      }
    }
  }
`;

const MOVE_APPLICANT_TO_APPLIED = gql`
  mutation moveMissionRoleApplicantsToApplied($input: MoveMissionRoleApplicantsToAppliedInput!) {
    moveMissionRoleApplicantsToApplied(input: $input) {
      applied {
        id
        state
      }
      failedToApply {
        id
        state
      }
    }
  }
`;

const UPDATE_APPLICANT_STATE = gql`
  ${APPLICANT_ACTIVITY_FIELDS}
  mutation updateMissionRoleApplicantState($input: UpdateMissionRoleApplicantStateInput!) {
    updateMissionRoleApplicantState(input: $input) {
      missionRoleApplicant {
        id
        state
        ...ApplicantActivityFields
      }
    }
  }
`;

const SEND_APPLICANT_NOTIFICATION = gql`
  ${APPLICANT_ACTIVITY_FIELDS}
  mutation sendMissionRoleApplicantNotification($input: SendMissionRoleApplicantNotificationInput!) {
    sendMissionRoleApplicantNotification(input: $input) {
      missionRoleApplicant {
        id
        state
        ...ApplicantActivityFields
      }
    }
  }
`;

const GENERATE_APPLICATION_PREVIEW_TOKEN = gql`
  mutation generateApplicationPreviewToken($input: GenerateApplicationPreviewTokenInput!) {
    generateApplicationPreviewToken(input: $input) {
      token
      expiresAt
    }
  }
`;

export {
  SUBMIT_APPLICATION,
  SHORTLIST_APPLICANT,
  UNSELECT_APPLICANT,
  UPDATE_APPLICANT,
  SELECT_APPLICANT,
  INTERVIEW_APPLICANT,
  MOVE_APPLICANT_TO_APPLIED,
  SEND_APPLICANT_NOTIFICATION,
  UPDATE_APPLICANT_STATE,
  WITHDRAW_APPLICATION,
  GENERATE_APPLICATION_PREVIEW_TOKEN,
};
